if (!customElements.get("po-header-wrapper")) {
    customElements.define("po-header-wrapper", class extends HTMLElement {
        connectedCallback () {
            this.lastScrollTop = 0;
            this.headerEl = this.querySelector("header");
            this.headerBlocks = this.querySelectorAll("[data-header-block]");
            this.logoWrapper = this.querySelector("[data-logo-wrapper]");
            this.scrollLogo = this.querySelector("[data-scroll-logo]");
            this.staticLogo = this.querySelector("[data-static-logo]");
            this.showSearchBtns = this.querySelectorAll("[data-show-search]");
            this.showCartBtns = this.querySelectorAll("[data-cart-ic-id]");
            this.ddmBadges = this.querySelectorAll(".js-ddm-badge");
            
            this.isTransparentOnTop = this.hasAttribute("data-transparent-on-top");
            this.blockBgClass = this.headerEl?.getAttribute("data-block-bg-class");
            this.separatorClass = this.headerEl?.getAttribute("data-separator-class");
            this.hideOnScroll = this.headerEl?.hasAttribute("data-hide-on-scroll");
            this.sectionId = this.headerEl?.getAttribute("data-section-id");

            this.showCartBtn_handler = (e) => this.showCart(e);
            this.showSearchBtn_handler = () => this.showSearch();
            this.window_scrollHandler = () => this.updateHeaderScroll();
            this.ddmBadge_clickHandler = (event) => {
                event.preventDefault();
                event.stopPropagation();
            };

            window.addEventListener("scroll", this.window_scrollHandler);
            this.showSearchBtns.forEach(btn => btn.addEventListener("click", this.showSearchBtn_handler));
            this.ddmBadges.forEach(badge => badge.addEventListener("click", this.ddmBadge_clickHandler));

            if (this.showCartBtns.length > 0) {
                this.showCartBtns.forEach(btn => btn.addEventListener("click", this.showCartBtn_handler));
                this.setCartBtnId(this.showCartBtns[0].getAttribute("data-cart-ic-id"));
            }
            
            if (this.isTransparentOnTop) {
                this.staticLogo?.classList.remove("tw-hidden");
                this.updateHeaderScroll();
            }
        }

        disconnectedCallback () {
            window.removeEventListener("scroll", this.window_scrollHandler);
            this.showSearchBtns.forEach(btn => btn.removeEventListener("click", this.showSearchBtn_handler));
            this.ddmBadges.forEach(badge => badge.removeEventListener("click", this.ddmBadge_clickHandler));
        }

        setCartBtnId (id) {
            if (this.showCartBtns.length > 0 && id && !document.getElementById(id)) {
                this.showCartBtns[0].id = id;
            }
        }

        showCart (clickEvent) {
            const cartDrawerWrapper = document.querySelector("cart-drawer");

            if (cartDrawerWrapper) {
                clickEvent.preventDefault();
                cartDrawerWrapper.open(clickEvent.target);
            }
        }

        showSearch () {
            const overlay = document.querySelector("#headerSearch-" + this.sectionId);
            
            if (!overlay) return;

            // Ensure the search overlay is attached to <body> so fixed positioning
            // is relative to the viewport and not constrained by sticky header wrappers.
            if (overlay.parentElement !== document.body) {
                document.body.appendChild(overlay);
            }

            if (window.innerWidth < 601) {
                overlay.style.position = "fixed";
                overlay.style.left = "0";
                overlay.style.right = "0";
                overlay.style.top = "0";
                overlay.style.bottom = "0";
                overlay.style.width = "100vw";
                overlay.style.maxWidth = "100vw";
                overlay.style.height = "100dvh";
                overlay.style.minHeight = "100dvh";
                overlay.style.margin = "0";
                overlay.style.paddingTop = "0";
                overlay.style.zIndex = "9999";
            }

            overlay.classList.add("show");

            requestAnimationFrame(() => {
                const input =
                    overlay.querySelector(".aa-Input") ||
                    overlay.querySelector('input[type="search"]');
                if (input) {
                    input.focus({ preventScroll: true });
                    if (typeof input.setSelectionRange === "function") {
                        const length = input.value?.length || 0;
                        input.setSelectionRange(length, length);
                    }
                }
            });
        }

        toggleScrollLogo (scrolling) {
            if (this.scrollLogo && this.staticLogo) {
                this.scrollLogo.style.display = scrolling ? "block" : "none";
                this.staticLogo.style.display = scrolling ? "none" : "block";
            }
        }

        updateHeaderScroll () {
            const scrollYPos = window.scrollY || document.documentElement.scrollTop;
            const scrolled = scrollYPos > this.headerEl.offsetHeight;
            const isScrollingDown = scrollYPos > this.lastScrollTop;

            if (this.isTransparentOnTop) {
                this.toggleScrollLogo(scrolled);
            }

            if (this.separatorClass) {
                this.headerEl.classList.toggle(this.separatorClass, scrolled);
            }

            if (this.blockBgClass && this.isTransparentOnTop) {
                this.headerBlocks.forEach(block => {
                    if (!block.hasAttribute("data-prevent-bg-change")) {
                        block.classList.toggle(this.blockBgClass, scrolled);
                    }
                });
            }

            if (this.hideOnScroll && scrolled) {
                this.headerEl.style.top = isScrollingDown ? `-${this.headerEl.offsetHeight}px` : "0";
                this.toggleAttribute("data-scroll-hidden", isScrollingDown);
            }

            this.dataset.scrolling = scrolled;
            this.dataset.isTransparent = !scrolled && this.isTransparentOnTop;

            this.lastScrollTop = scrollYPos;
        }
    });
}
